export default class AbstractModel {
  mapper () {
    return []
  }

  validator () {
    return {}
  }

  permission () {
    return {}
  }

  selector () {
    return null
  }
}
